/**
 * Minimalerei Gift Guide — dot pagination for mobile scroll-slider
 *
 * Desktop/tablet render as a static grid; mobile (≤640px) renders
 * as a horizontal CSS scroll-snap slider. This JS adds dot
 * indicators to the mobile slider — one dot per card, active dot
 * tracks the closest snap position based on scrollLeft. Clicking
 * a dot scrolls smoothly to that card.
 *
 * Dots are hidden on desktop/tablet via a viewport check on init
 * and resize; layout stays clean when there's no scrolling.
 */
(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 640px)';

  function initGuide(root) {
    if (root.dataset.mpGiftInitialized === 'true') return;
    root.dataset.mpGiftInitialized = 'true';

    var grid = root.querySelector('.mp-gift__grid');
    var dotsContainer = root.querySelector('[data-mp-gift-dots]');
    if (!grid || !dotsContainer) return;

    var cards = Array.from(grid.children);
    if (cards.length === 0) return;

    var mq = window.matchMedia(MOBILE_QUERY);

    function buildDots() {
      dotsContainer.innerHTML = '';

      if (!mq.matches || cards.length < 2) {
        dotsContainer.style.display = 'none';
        return;
      }
      dotsContainer.style.display = 'flex';

      for (var i = 0; i < cards.length; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'mp-gift__dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Karte ' + (i + 1) + ' von ' + cards.length);
        if (i === 0) {
          dot.classList.add('is-active');
          dot.setAttribute('aria-selected', 'true');
        }
        (function (index) {
          dot.addEventListener('click', function () { scrollToCard(index); });
        })(i);
        dotsContainer.appendChild(dot);
      }
    }

    function scrollToCard(index) {
      var card = cards[index];
      if (!card) return;
      var gridPaddingLeft = parseFloat(getComputedStyle(grid).paddingLeft) || 0;
      grid.scrollTo({
        left: card.offsetLeft - gridPaddingLeft,
        behavior: 'smooth'
      });
    }

    function updateActiveDot() {
      var dots = dotsContainer.querySelectorAll('.mp-gift__dot');
      if (dots.length === 0) return;

      var scrollLeft = grid.scrollLeft;
      var gridPaddingLeft = parseFloat(getComputedStyle(grid).paddingLeft) || 0;
      var closestIndex = 0;
      var closestDistance = Infinity;

      cards.forEach(function (card, i) {
        var snapPosition = card.offsetLeft - gridPaddingLeft;
        var distance = Math.abs(snapPosition - scrollLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = i;
        }
      });

      dots.forEach(function (dot, i) {
        if (i === closestIndex) {
          dot.classList.add('is-active');
          dot.setAttribute('aria-selected', 'true');
        } else {
          dot.classList.remove('is-active');
          dot.setAttribute('aria-selected', 'false');
        }
      });
    }

    var scrollDebounce;
    grid.addEventListener('scroll', function () {
      clearTimeout(scrollDebounce);
      scrollDebounce = setTimeout(updateActiveDot, 50);
    }, { passive: true });

    var resizeDebounce;
    window.addEventListener('resize', function () {
      clearTimeout(resizeDebounce);
      resizeDebounce = setTimeout(buildDots, 150);
    });

    buildDots();
  }

  function boot() {
    document.querySelectorAll('[data-mp-gift]').forEach(initGuide);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
